import React from "react";
import { PlayerInfo } from "../../lib/models/PlayerInfo";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { usePlayerGameStatusUpdate } from "../../hooks/usePlayerGameStatusUpdate";

export const PlayerPlayGameRow = ({ playerNumber, p, gameId }: { playerNumber: number, p: PlayerInfo, gameId: string }) => {

  return (
    <tr>
      <td>{playerNumber}. {p.id}</td>
      <td>{p.name}</td>
      <td>{p.round}</td>
      <td>{p.score}</td>
      <td>
        {/*
        {p.id ?
        (<Button color="link" onClick={() => handleUpdate()}>Update</Button>)
        : null}
        */}
        </td>
    </tr>
  )
}